// EPI Authority Info 信息体（可复用）
// 同时被两处使用：
//   1. ServiceRequestAuthorityInfoModal —— 点击 Show Info 按钮弹出的 AntDraggableModal
//   2. CustomButton —— Show Info 按钮 hover 时弹出的 Popover
// 作用：按传入的 LgaId / UtilityAuthorityId 拉取
//   - Council 的 Lodgement Info（本公司私有，Admin/LgaPrivateNote/GetDetailByLga）
//   - Water Authority 的 Property Info Lodgement（Admin/UtilityAuthority/GetDetail）
// 两段富文本用 dangerouslySetInnerHTML 渲染，里面链接可直接点击；
// 外层 className="service-request-authority-info"，由 site.css 把内部 <p> margin 置 0
import React from 'react';
import { Spin, Empty, Divider } from 'antd';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';

export default class ServiceRequestAuthorityInfoContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      privateNote: '',            // Council Lodgement Info（HTML）
      propertyInfoLodgement: '',  // Water Authority Property Info Lodgement（HTML）
    };
  }

  componentDidMount() {
    this.loadInfo();
  }

  // 并行拉取 Lodgement Info + Property Info Lodgement（哪个 Id 没有就跳过哪个）
  loadInfo = () => {
    const { lgaId, utilityAuthorityId } = this.props;
    const requests = [];

    if (lgaId) {
      requests.push(
        httpClient.get('/Admin/LgaPrivateNote/GetDetailByLga?lgaId=' + lgaId)
          .then(({ data }) => {
            if (data.result && data.data) {
              this.setState({ privateNote: data.data.Note || '' });
            }
          })
          .catch((error) => globalFunction.handleError(error, this))
      );
    }

    if (utilityAuthorityId) {
      requests.push(
        httpClient.get('/Admin/UtilityAuthority/GetDetail?utilityAuthorityId=' + utilityAuthorityId)
          .then(({ data }) => {
            if (data.result && data.data) {
              this.setState({ propertyInfoLodgement: data.data.PropertyInfoLodgement || '' });
            }
          })
          .catch((error) => globalFunction.handleError(error, this))
      );
    }

    if (requests.length === 0) { return; }
    this.setState({ loading: true });
    Promise.all(requests).finally(() => this.setState({ loading: false }));
  };

  render() {
    const { lgaName, utilityAuthorityName, lgaId, utilityAuthorityId } = this.props;
    const { privateNote, propertyInfoLodgement } = this.state;
    const hasPrivateNote = !globalFunction.isNullOrEmpty(privateNote);
    const hasPropertyInfo = !globalFunction.isNullOrEmpty(propertyInfoLodgement);

    return (
      <Spin spinning={this.state.loading}>
        {/* 合并展示区：富文本里链接可点击；className 供 site.css 去除 <p> 默认 margin */}
        <div className="service-request-authority-info">
          {/* Council Lodgement Info */}
          <h5 style={{ marginBottom: 8 }}>
            <b>{lgaName}</b>
          </h5>
          {hasPrivateNote
            ? <div style={{ marginBottom: 8 }} dangerouslySetInnerHTML={{ __html: privateNote }} />
            : <span style={{ color: '#bfbfbf', marginBottom: 8 }}>No Lodgement Info.</span>}

          <Divider />

          {/* Water Authority Property Info Lodgement */}
          <h5 style={{ marginBottom: 8, marginTop: 8 }}>
            <b>{utilityAuthorityName}</b>
          </h5>
          {hasPropertyInfo
            ? <div dangerouslySetInnerHTML={{ __html: propertyInfoLodgement }} />
            : <span style={{ color: '#bfbfbf' }}>No Lodgement Info.</span>}

          {/* 两个 Id 都没有时给个空态提示 */}
          {!lgaId && !utilityAuthorityId && (
            <Empty description="This job has no linked Council or Water Authority." />
          )}
        </div>
      </Spin>
    );
  }
}
